interface Dimensions {
  maxWidth: number,
  maxHeight: number
}

interface Options {
  dimensions?: Dimensions,
  onClose?: () => void,
}

interface HydratedOptions extends Options {
  dimensions: Dimensions
}

function getWidth(maxWidth: number): number {
  const width = window.screen.availWidth;
  return (width > maxWidth) ? maxWidth : width;
}

function getHeight(maxHeight: number): number {
  const height = window.screen.availHeight;
  return (height > maxHeight) ? maxHeight : height;
}

const defaultOptions:HydratedOptions = {
  dimensions: {
    maxWidth: 700,
    maxHeight: 700,
  },
};

function addCloseListener(win: Window, listener: () => void) {
  const check = () => {
    if (win.closed) {
      listener();
    } else {
      setTimeout(check, 1000);
    }
  };
  check();
}

export function openWindow(url: string, options?: Options) {
  const opts:HydratedOptions = { ...defaultOptions, ...options };
  const { maxWidth, maxHeight } = opts.dimensions;
  const width = getWidth(maxWidth);
  const height = getHeight(maxHeight);
  const win = window.open(
    url,
    '',
    `width=${width},height=${height},location=no,toolbar=no,menubar=no,status=no,titlebar=no`,
  );
  if (!win || !opts.onClose) return;
  addCloseListener(win, opts.onClose);
}
